export default __webpack_public_path__ + "static/media/exam-beep.208aefe9.png";